"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _button = _interopRequireDefault(require("../../../../core/button"));
var _exportButton = _interopRequireDefault(require("../../../../core/export-button"));
var _modal = _interopRequireDefault(require("../../../../core/modal"));
var _alert = _interopRequireDefault(require("../../../../core/alert"));
var _input = _interopRequireDefault(require("../../../../core/input"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const columnOptions = [{
  id: 'isPromoted',
  label: 'Promoted Indicator'
}, {
  id: 'clashesWith',
  label: 'Also Competing In'
}, {
  id: 'entrySortDate',
  label: 'Date Entered'
}, {
  id: 'competitionDay',
  label: 'Day of Race'
}, {
  id: 'raceName',
  label: 'Race Entered'
}, {
  id: 'ranking',
  label: 'Paddler Ranking'
}, {
  id: 'startListBib',
  label: 'Bib Number'
}, {
  id: 'bibName',
  label: 'Paddler Name'
}, {
  id: 'ageCategoryDescription',
  label: 'Age Category'
}, {
  id: 'clubName',
  label: 'Club Name'
}, {
  id: 'freeCode',
  label: 'Organiser Code'
}, {
  id: 'contactEmail',
  label: 'Contact Email Address'
}, {
  id: 'membershipNations',
  label: 'National Association(s)'
}, {
  id: 'bcNumbers',
  label: 'National Association Number(s)'
}, {
  id: 'bcExpiryDates',
  label: 'National Association Expiry Date(s)'
}, {
  id: 'isLateEntry',
  label: 'Late Entry Indicator'
}, {
  id: 'isOnlineEntry',
  label: 'Online Entry Indicator'
}, {
  id: 'hasPaid',
  label: 'Has Paid Indicator'
}, {
  id: 'entryTypeDescription',
  label: 'Entry Type'
}, {
  id: 'rtcRefs',
  label: 'RTC Codes'
}, {
  id: 'rtcNotes',
  label: 'RTC Notes'
}];

// note all columns are selected by default except for contactEmail address and National Association Membership info
const DEFAULT_SELECTED_COLUMNS = ['isPromoted', 'clashesWith', 'entrySortDate', 'competitionDay', 'raceName', 'ranking', 'startListBib', 'bibName', 'ageCategoryDescription', 'clubName', 'freeCode', 'isLateEntry', 'isOnlineEntry', 'hasPaid', 'entryTypeDescription', 'rtcRefs', 'rtcNotes'];
const initialState = {
  selectingColumnsToExport: false,
  // note all columns are selected by default except for contactEmail address
  defaultSelect: true,
  selectedColumns: DEFAULT_SELECTED_COLUMNS
};
var _ref = /*#__PURE__*/_react.default.createElement(_alert.default, {
  type: "danger"
}, "THINK PRIVACY. Do not download email addresses for lists that will be widely shared or available to others. Only download what you need.");
class ExportEntries extends _react.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", initialState);
    _defineProperty(this, "_onToggleSelected", (id, selected) => {
      this.setState({
        selectedColumns: selected ? this.state.selectedColumns.concat([id]) : this.state.selectedColumns.filter(i => i !== id)
      });
    });
    _defineProperty(this, "_setDefaultColumns", () => {
      this.setState({
        defaultSelect: true,
        selectedColumns: DEFAULT_SELECTED_COLUMNS
      });
    });
    _defineProperty(this, "_toggleAll", () => {
      if (this.state.defaultSelect) {
        this.setState({
          defaultSelect: false,
          selectedColumns: []
        });
      } else {
        this._setDefaultColumns();
      }
    });
    _defineProperty(this, "_isSelected", id => {
      return this.state.selectedColumns.indexOf(id) !== -1;
    });
    _defineProperty(this, "_onCloseCancel", () => {
      this.setState(initialState);
    });
    _defineProperty(this, "_onBeginExport", () => {
      this.setState({
        selectingColumnsToExport: true
      });
    });
  }
  render() {
    const entry = this.props.entry;
    const modalButtons = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._onCloseCancel
    }, "Close"), /*#__PURE__*/_react.default.createElement(_exportButton.default, {
      name: this.props.name,
      args: {
        competitionSlug: this.props.competitionSlug,
        yearID: this.props.yearID,
        selectedColumns: this.state.selectedColumns
      },
      disabled: this.state.selectedColumns.length === 0,
      type: "primary",
      onClick: this._onCloseCancel
    }, this.props.buttonName || 'Export Entries'));
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_button.default, {
      style: {
        marginBottom: 8
      },
      onClick: this._onBeginExport
    }, this.props.children), !this.state.selectingColumnsToExport ? null : /*#__PURE__*/_react.default.createElement(_modal.default, {
      title: "Select Columns to Export",
      buttons: modalButtons,
      onClose: this._onCloseCancel
    }, _ref, /*#__PURE__*/_react.default.createElement(_button.default, {
      onClick: this._toggleAll
    }, this.state.defaultSelect ? 'De-select All' : 'Reset Default'), columnOptions.map(option => /*#__PURE__*/_react.default.createElement("div", {
      key: option.id
    }, option.id === 'freeCode' && !this.props.useFreeCode ? null : /*#__PURE__*/_react.default.createElement(_input.default, {
      type: "Checkbox",
      checked: this._isSelected(option.id),
      onChange: this._onToggleSelected.bind(this, option.id),
      label: option.label
    })))));
  }
}

// *******************************************************************************
// Data and actions
// *******************************************************************************
var _default = exports.default = ExportEntries;